import MyEnrolledCourses from "./MyEnrolledCourses"

export default function MyCoursesSection() {
  return (
    <div className="space-y-6">
      {/* Afficher les cours inscrits */}
      <MyEnrolledCourses />
    </div>
  )
}
